import { Typography } from '@mui/material';

import { cn } from '@/shared/lib/cn';

interface AppFooterProps {
  className?: string;
}

/**
 * The compliance line, closing out the main content column.
 *
 * It sits at the end of the content rather than in fixed chrome: a pinned
 * strip would compete with the bottom nav for the same 64px of thumb space on
 * a phone, and the line is a legal footnote, not a control worth that room.
 */
export const AppFooter = ({ className }: AppFooterProps) => (
  <Typography
    component="p"
    variant="caption"
    color="text.secondary"
    className={cn('text-center leading-none', className)}
  >
    © Powered by Waive Corporate Compliance 2026
  </Typography>
);
